import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import LoadScript from 'vue-plugin-load-script'

Vue.use(LoadScript)
Vue.use(Vuetify)

export default new Vuetify({

  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#23282D',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        boxHL: '#EEEADC',
        isBlue: '#01B7D2',
        isYellow: '#FFCE3C',
        isRed: '#CC0F76',
        isBlack: '#000000'
      }
    }
  }
})
